
export const TIKTOK_SCRIPTS = [
    {
        id: "tiktok-dicas-rapidas",
        title: { pt: "3 Dicas Rápidas (Viral)", en: "3 Quick Tips (Viral)", es: "3 Consejos Rápidos (Viral)" },
        tags: ["TikTok", "Dicas", "Viral"],
        content: {
            pt: `<r>GANCHO (3s)</r>
Pare de [ERRO COMUM] agora mesmo!
<y>CORPO (25s)</r>
Se você quer [RESULTADO], faça isso:
1. [DICA 1]: Muita gente ignora, mas é essencial para [BENEFÍCIO].
2. [DICA 2]: Esse é o pulo do gato. Use [FERRAMENTA/TÉCNICA] para dobrar seus resultados.
3. [DICA 3]: O mais importante... (pausa dramática)... [O SEGREDO].
<g>CTA (5s)</r>
Salva esse vídeo para não esquecer a dica 3 e me segue para mais!`,
            en: `<r>HOOK (3s)</r>
Stop [COMMON MISTAKE] right now!
<y>BODY (25s)</r>
If you want [RESULT], do this:
1. [TIP 1]: Many ignore this, but it's essential for [BENEFIT].
2. [TIP 2]: This is the game changer. Use [TOOL/TECHNIQUE] to double your results.
3. [TIP 3]: The most important one... (dramatic pause)... [THE SECRET].
<g>CTA (5s)</r>
Save this video so you don't forget tip 3 and follow me for more!`,
            es: `<r>GANCHO (3s)</r>
¡Deja de [ERROR COMÚN] ahora mismo!
<y>CUERPO (25s)</r>
Si quieres [RESULTADO], haz esto:
1. [CONSEJO 1]: Mucha gente lo ignora, pero es esencial para [BENEFICIO].
2. [CONSEJO 2]: Este es el truco. Usa [HERRAMIENTA/TÉCNICA] para duplicar tus resultados.
3. [CONSEJO 3]: Lo más importante... (pausa dramática)... [EL SECRETO].
<g>CTA (5s)</r>
¡Guarda este video para no olvidar el consejo 3 y sígueme para más!`
        }
    },
    {
        id: "tiktok-mito-verdade",
        title: { pt: "Mito vs Verdade", en: "Myth vs Truth", es: "Mito vs Verdad" },
        tags: ["TikTok", "Curiosidade", "Educação"],
        content: {
            pt: `<r>TEXTO NA TELA: "Isso é mentira!"</r>
Você já ouviu falar que [MITO FAMOSO]?
Pois é, te enganaram a vida toda.
<y>EXPLICAÇÃO RÁPIDA</r>
A verdade é que [REALIDADE].
Isso acontece porque [EXPLICAÇÃO CIENTÍFICA/LÓGICA].
Olha esse exemplo: [EXEMPLO VISUAL].
<g>CTA</r>
Sabia dessa? Manda esse vídeo pra aquele amigo que ainda acredita em [MITO].`,
            en: `<r>TEXT ON SCREEN: "That's a lie!"</r>
Have you heard that [FAMOUS MYTH]?
Well, you've been fooled your whole life.
<y>QUICK EXPLANATION</r>
The truth is that [REALITY].
This happens because [SCIENTIFIC/LOGICAL EXPLANATION].
Look at this example: [VISUAL EXAMPLE].
<g>CTA</r>
Did you know this? Send this video to that friend who still believes in [MYTH].`,
            es: `<r>TEXTO EN PANTALLA: "¡Eso es mentira!"</r>
¿Has oído hablar de que [MITO FAMOSO]?
Pues sí, te han engañado toda la vida.
<y>EXPLICACIÓN RÁPIDA</r>
La verdad es que [REALIDAD].
Esto sucede porque [EXPLICACIÓN CIENTÍFICA/LÓGICA].
Mira este ejemplo: [EJEMPLO VISUAL].
<g>CTA</r>
¿Sabías esto? Envía este video a ese amigo que todavía cree en [MITO].`
        }
    },
    {
        id: "tiktok-bastidores",
        title: { pt: "Bastidores / Behind the Scenes", en: "Behind the Scenes", es: "Detrás de Cámaras" },
        tags: ["TikTok", "Lifestyle", "Humanização"],
        content: {
            pt: `<r>GANCHO</r>
O que ninguém te mostra sobre [SEU TRABALHO/PRODUTO].
<y>CORPO</r>
Vocês veem o resultado final assim: [FOTO BONITA].
Mas a realidade é essa aqui: [MOSTRAR BAGUNÇA/TRABALHO DURO].
Hoje eu tive que resolver [PROBLEMA] e quase desisti quando [OSBTÁCULO].
Mas no final, vale a pena ver o cliente feliz.
<g>CTA</r>
Quer ver mais da rotina de um [PROFISSÃO]? Comenta "Bastidores".`,
            en: `<r>HOOK</r>
What no one shows you about [YOUR WORK/PRODUCT].
<y>BODY</r>
You see the final result like this: [NICE PHOTO].
But the reality is this: [SHOW MESS/HARD WORK].
Today I had to solve [PROBLEM] and almost gave up when [OBSTACLE].
But in the end, it's worth seeing the client happy.
<g>CTA</r>
Want to see more of a [PROFESSION] routine? Comment "BTS".`,
            es: `<r>GANCHO</r>
Lo que nadie te muestra sobre [TU TRABAJO/PRODUCTO].
<y>CUERPO</r>
Ustedes ven el resultado final así: [FOTO BONITA].
Pero la realidad es esta: [MOSTRAR DESORDEN/TRABAJO DURO].
Hoy tuve que resolver [PROBLEMA] y casi me rindo cuando [OBSTÁCULO].
Pero al final, vale la pena ver al cliente feliz.
<g>CTA</r>
¿Quieres ver más de la rutina de un [PROFESIÓN]? Comenta "Detrás de cámaras".`
        }
    },
    {
        id: "tiktok-pov",
        title: { pt: "POV (Point of View)", en: "POV (Point of View)", es: "POV (Punto de Vista)" },
        tags: ["TikTok", "Humor", "Tendência"],
        content: {
            pt: `<r>CENA 1 (PERNAGEM A)</r>
POV: Você é o cliente que pede "só uma alteraçãozinha".
Cliente: "Oi, ficou ótimo! Mas tem como mudar a cor, a fonte e o layout inteirinho?"
<y>CENA 2 (PERSONAGEM B - VOCÊ)</r>
Eu: (Cara de desespero sorrindo) "Claro! É pra já..."
(Pensamento: Lá se vai meu fim de semana.)
<g>CTA</r>
Quem se identifica? Marca seu amigo designer/freelancer pra chorar junto.`,
            en: `<r>SCENE 1 (CHARACTER A)</r>
POV: You are the client who asks for "just a small change".
Client: "Hi, looks great! But can you change the color, the font and the entire layout?"
<y>SCENE 2 (CHARACTER B - YOU)</r>
Me: (Desperate face smiling) "Sure! Right away..."
(Thought: There goes my weekend.)
<g>CTA</r>
Who relates? Tag your designer/freelancer friend to cry together.`,
            es: `<r>ESCENA 1 (PERSONAJE A)</r>
POV: Eres el cliente que pide "solo un pequeño cambio".
Cliente: "¡Hola, quedó genial! ¿Pero puedes cambiar el color, la fuente y todo el diseño?"
<y>ESCENA 2 (PERSONAJE B - TÚ)</r>
Yo: (Cara de desesperación sonriendo) "¡Claro! Enseguida..."
(Pensamiento: Adiós a mi fin de semana.)
<g>CTA</r>
¿Quién se identifica? Etiqueta a tu amigo diseñador/freelancer para llorar juntos.`
        }
    },
    {
        id: "tiktok-did-you-know",
        title: { pt: "Você Sabia? (Curiosidade)", en: "Did You Know? (Curiosity)", es: "¿Sabías Que? (Curiosidad)" },
        tags: ["TikTok", "Curiosidade", "Fato"],
        content: {
            pt: `<r>GANCHO</r>
Você sabia que [FATO CURIOSO]?
Eu aposto que você fazia [COISA ERRADA] sem saber disso.
<y>EXPLICAÇÃO</r>
Isso acontece por causa do [EFEITO/LEI].
Em 1990, um estudo mostrou que [DADO ESTATÍSTICO].
Isso explica porque você sempre sente [SENSAÇÃO] quando [SITUAÇÃO].
<g>CTA</r>
Incrível né? Já sabia dessa? Me conta aqui.`,
            en: `<r>HOOK</r>
Did you know that [CURIOUS FACT]?
I bet you were doing [WRONG THING] without knowing this.
<y>EXPLANATION</r>
This happens because of the [EFFECT/LAW].
In 1990, a study showed that [STATISTIC].
This explains why you always feel [SENSATION] when [SITUATION].
<g>CTA</r>
Amazing right? Did you know this? Tell me here.`,
            es: `<r>GANCHO</r>
¿Sabías que [HECHO CURIOSO]?
Apuesto a que hacías [COSA INCORRECTA] sin saberlo.
<y>EXPLICACIÓN</r>
Esto sucede debido al [EFECTO/LEY].
En 1990, un estudio mostró que [DATO ESTADÍSTICO].
Esto explica por qué siempre sientes [SENSACIÓN] cuando [SITUACIÓN].
<g>CTA</r>
Increíble ¿no? ¿Ya lo sabías? Cuéntame aquí.`
        }
    },
    {
        id: "tiktok-life-hack",
        title: { pt: "Life Hack Rápido", en: "Quick Life Hack", es: "Truco de Vida Rápido" },
        tags: ["TikTok", "Dicas", "Utilidade"],
        content: {
            pt: `<r>PROBLEMA</r>
Cansado de [PROBLEMA COMUM DO DIA A DIA]?
Olha esse hack que vai salvar sua vida.
<y>SOLUÇÃO</r>
Tudo que você precisa é de [OBJETO SIMPLES].
1. Pegue o [OBJETO].
2. Coloque em [LUGAR].
3. E pronto!
<g>RESULTADO</r>
Agora você nunca mais vai sofrer com [PROBLEMA].
Gostou? Já me segue para mais dicas de produtividade!`,
            en: `<r>PROBLEM</r>
Tired of [COMMON DAILY PROBLEM]?
Watch this hack that will save your life.
<y>SOLUTION</r>
All you need is a [SIMPLE OBJECT].
1. Take the [OBJECT].
2. Put it in [PLACE].
3. And done!
<g>RESULT</r>
Now you will never struggle with [PROBLEM] again.
Liked it? Follow me for more productivity tips!`,
            es: `<r>PROBLEMA</r>
¿Cansado de [PROBLEMA COMÚN DIARIO]?
Mira este truco que salvará tu vida.
<y>SOLUCIÓN</r>
Todo lo que necesitas es un [OBJETO SIMPLE].
1. Toma el [OBJETO].
2. Ponlo en [LUGAR].
3. ¡Y listo!
<g>RESULTADO</r>
Ahora nunca más sufrirás con [PROBLEMA].
¿Te gustó? ¡Sígueme para más consejos de productividad!`
        }
    },
    {
        id: "tiktok-motivation",
        title: { pt: "Citação Motivacional", en: "Motivational Quote", es: "Cita Motivacional" },
        tags: ["TikTok", "Inspiração", "Mindset"],
        content: {
            pt: `<r>(MÚSICA ÉPICA AO FUNDO)</r>
Escuta isso.
"O sucesso é a soma de pequenos esforços repetidos dia após dia."
<y>REFLEXÃO</r>
Você pode estar cansado hoje.
Pode parecer que nada está acontecendo.
Mas cada passo conta.
Não desista agora, você está mais perto do que imagina.
<g>CTA</r>
Digite "EU VOU CONSEGUIR" nos comentários se você acredita nisso.`,
            en: `<r>(EPIC MUSIC BACKGROUND)</r>
Listen to this.
"Success is the sum of small efforts repeated day in and day out."
<y>REFLECTION</r>
You might be tired today.
It might seem like nothing is happening.
But every step counts.
Don't give up now, you are closer than you think.
<g>CTA</r>
Type "I WILL MAKE IT" in the comments if you believe this.`,
            es: `<r>(MÚSICA ÉPICA DE FONDO)</r>
Escucha esto.
"El éxito es la suma de pequeños esfuerzos repetidos día tras día."
<y>REFLEXIÓN</r>
Puede que estés cansado hoy.
Puede parecer que no pasa nada.
Pero cada paso cuenta.
No te rindas ahora, estás más cerca de lo que imaginas.
<g>CTA</r>
Escribe "LO LOGRARÉ" en los comentarios si crees en esto.`
        }
    }
];
